export const statistics = state => state.getPStatisticsState;
export const statisticsProducts = state => state.getPStatisticsProductsState;
export const statisticsPerHour = state => state.getStatisticsPerHourState;
